/* global ymaps, storeId, yaMapsKey, dataLayer */
define([
    'jquery',
    'fancybox',
    'mage/template',
    'Oggetto_Boutique/js/geo-data',
    'domReady',
    'mage/cookies'
], function ($, fancybox, mageTemplate, geoData, domReady) {
    const COOKIE_NAME = 'boutique_location';
    const COOKIE_STORE_ID = 'store_id';

    let expDate = new Date();
    expDate.setTime(expDate.getTime() + (60 * 60 * 1000)); // add 60 minutes

    const cookieSetting = {
        path: '/',
        domain: '',
        expires: expDate
    };

    return {
        init(params) {
            this.params = params;

            if (!$.cookie(COOKIE_STORE_ID)) {
                $.cookie(COOKIE_STORE_ID, storeId, cookieSetting);
            }

            if ($.cookie(COOKIE_NAME) && Number($.cookie(COOKIE_STORE_ID)) === storeId) return;

            window.onloadMapsApi = this.onloadMapsApi.bind(this);

            this.initCache();
            this.bindEvents();

            geoData.address.subscribe(this.addressChanged, this);
        },

        initCache() {
            this.mapsApiScript = null;

            this.$body = $('body');
            this.boutiquesList = '.js-boutiques';
            this.boutiquesSelectList = '.js-boutiques-select-list';
            this.boutiqueSelect = '#boutiqueSelect';
            this.boutiqueSearchBlock = '.js-boutiques-search';
            this.boutiqueConfirmBtn = '.js-boutique-confirm';
            this.otherBoutiqueBtn = '.js-find-other-boutique';
            this.isNeedGetGeolocation = true;
        },

        bindEvents() {
            domReady(this.onLoadWindow.bind(this));

            this.$body
                .on('click', this.boutiqueConfirmBtn, this.confirmBoutique.bind(this))
                .on('change', this.boutiqueSelect, this.confirmBoutique.bind(this))
                .on('click', this.otherBoutiqueBtn, this.getOther.bind(this))
        },

        onLoadWindow() {
            this.getBrowserLocation();
        },

        getBrowserLocation() {
            let success = (position) => {
                const latitude  = position.coords.latitude;
                const longitude = position.coords.longitude;

                this.pushDataLayer('select: use browser geolocation', 'allow');
                this.getBoutique(latitude, longitude, 'browser');
            }

            let error = () => {
                this.pushDataLayer('select: use browser geolocation', 'block');
                this.loadMapsApiScript();
            };

            if (!navigator.geolocation) {
                console.log('Geolocation is not supported by your browser');
                this.pushDataLayer('select: use browser geolocation', 'Geolocation is not supported by your browser');
                this.loadMapsApiScript();
            } else {
                navigator.geolocation.getCurrentPosition(success, error);
            }
        },

        confirmBoutique(ev) {
            const $boutique = $(ev.currentTarget);
            const eventType = ev.type;
            const boutiqueId = eventType === 'change' ? $boutique.val() : $boutique.data('boutique-id');

            this.pushDataLayer('select: boutique', boutiqueId);
            $.cookie(COOKIE_NAME, 'close', cookieSetting);

            $.fancybox.close();
        },

        loadMapsApiScript() {
            const isYaMapsApiAlreadyLoad = $('[src*="api-maps.yandex"]').length;

            if (isYaMapsApiAlreadyLoad) {
                this.onloadMapsApi();
                return;
            }

            this.mapsApiScript = $('<script>', {
                src: `https://api-maps.yandex.ru/2.1?apikey=${yaMapsKey}&lang=ru-RU&load=geolocation,SuggestView,geocode&onload=onloadMapsApi`,
                attr: {
                    defer: true
                }
            }).appendTo(this.$body);
        },

        onloadMapsApi() {
            ymaps.ready(() => {
                if (this.isNeedGetGeolocation) {
                    const geolocation = ymaps.geolocation;

                    this.getGeolocationData(geolocation);
                }
            })
        },

        getGeolocationData(geolocation) {
            geolocation
                .get({
                    provider: 'yandex'
                })
                .then(
                    result => {
                        const geocoderMetaData = result.geoObjects.get(0).properties.get('metaDataProperty').GeocoderMetaData;
                        const administrativeArea = geocoderMetaData.AddressDetails.Country.AdministrativeArea;
                        const city = administrativeArea.SubAdministrativeArea.Locality.LocalityName;
                        const positionArray = result.geoObjects.position;

                        this.pushDataLayer('use geolocation ip', 'success');
                        this.getBoutique(positionArray[0], positionArray[1], 'ip');
                    },
                    error => {
                        console.log(`Yandex geolocation error: ${error.message}`);
                        this.pushDataLayer('use geolocation ip', `error: ${error.message}`);
                    }
                );
        },

        getBoutique(latitude, longitude, source) {
            const url = `${this.params.url}search/${storeId}/${latitude}/${longitude}/${source}`

            this.sendRequest(
                url
            ).done((data) => {
                $(this.boutiquesList).html($(this.returnTmpl('#boutiqueTmpl', data)));

                if (data.length) {
                    this.pushDataLayer('get: boutique', this.getBoutiquesIds(data));
                    $.cookie(COOKIE_NAME, data[0].sfa_code, cookieSetting);
                } else {
                    this.pushDataLayer('get: boutique', 'boutique not identified');
                    $.cookie(COOKIE_NAME, 'empty', cookieSetting);

                    this.isNeedGetGeolocation = false;
                }

                if (this.isPopupOpen) return;

                $.fancybox({
                    href: '#boutiquePopup',
                    wrapCSS: 'boutique-popup-wr',
                    scrolling: 'auto',
                    width: '90%',
                    padding: '0',
                    autoHeight: true,
                    tpl: {
                        closeBtn: '<button type="button" title="close" class="boutique-popup-close"></button>'
                    },
                    afterShow: () => {
                        this.isPopupOpen = true;
                    },
                    beforeClose: () => {
                        if ($.cookie(COOKIE_NAME) !== 'close') {
                            this.pushDataLayer('popup closed', 'not confirm boutique');
                            return;
                        }

                        $.cookie(COOKIE_NAME, 'close', cookieSetting);
                        this.isPopupOpen = false;
                    },
                });
            });
        },

        getOther(ev) {
            const $btn = $(ev.currentTarget);

            $(this.boutiquesList).hide();
            $(this.boutiquesSelectList).hide();
            $(this.boutiqueSearchBlock).show();

            this.pushDataLayer('select: get other boutique', $btn.text());

            this.loadMapsApiScript();
        },

        addressChanged: function(address) {
            this.pushDataLayer('select: city', address.value);

            this.getCoordinatesByCity(address.value);
        },

        getCoordinatesByCity(city) {
            ymaps.ready(() => {
                ymaps.geocode(city, {
                    results: 1
                }).then((res) => {
                    const firstGeoObject = res.geoObjects.get(0);
                    const coords = firstGeoObject.geometry.getCoordinates();
                    const url = `${this.params.url}searchByCity/${storeId}/${city}/${coords[0]}/${coords[1]}`;

                    this.getBoutiquesByCity(url);
                });
            })
        },

        getBoutiquesByCity(url) {
            this.sendRequest(
                url
            ).done((data) => {
                $(this.boutiqueSearchBlock).hide();
                $(this.boutiquesSelectList)
                    .html($(this.returnTmpl('#boutiqueSelectListTmpl', data)))
                    .show()

                this.pushDataLayer('get: boutique by city', this.getBoutiquesIds(data));
            });
        },

        getBoutiquesIds(boutiquesList) {
            return boutiquesList.reduce((list, item, index) => {
                return (index + 1 === boutiquesList.length) ? `${list}${item.sfa_code}` : `${list}${item.sfa_code}, `;
            }, '');
        },

        sendRequest(url, data) {
            data = data || {}

            return $.ajax({
                type: 'get',
                url: url,
                data: data,
                contentType: 'application/json; charset=utf-8',
                beforeSend() {

                }
            }).fail((xhr, status, errorThrown) => {
                console.log(xhr, status, errorThrown);
                this.pushDataLayer('XHR fail', `${status}: ${xhr.responseJSON.message}`);
            }).always(() => {

            });
        },

        returnTmpl(tmplId, data) {
            return mageTemplate(tmplId, { data: data });
        },

        pushDataLayer(action, label) {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'uaevent',
                    eventCategory: 'virtual try on::modiface',
                    eventAction: action,
                    eventLabel: label
                });
            }
        }

    };
});
